module.exports = __webpack_public_path__ + "img/Ellipse.8a19fa3c.svg";